import { makeStyles } from '@material-ui/styles';

const AppToolsErrorMessage = () => {
    const classes = useStyles();
    return <div className={classes.message}>Oops, something went wrong...</div>;
};

const useStyles = makeStyles(
    {
        message: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center',
            height: '100%',
            fontWeight: 'bold',
            fontSize: '2.5em',
            textAlign: 'center',
            padding: 20,
        },
    },
    { classNamePrefix: 'AppToolsErrorMessage' }
);

export default AppToolsErrorMessage;
